module.exports = __webpack_public_path__ + "static/media/settings.709e22aa.png";